function decodeBase64UrlToString(value) {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/');
  const normalized = padded + '='.repeat((4 - (padded.length % 4 || 4)) % 4);
  return atob(normalized);
}

/**
 * Extracts candidate user ids from a JWT payload (sub, _id, userId).
 */
export function getUserIdsFromJwt(token) {
  const raw = String(token || '').trim();
  if (!raw) {
    return [];
  }
  const parts = raw.split('.');
  if (parts.length !== 3) {
    return [];
  }
  try {
    const payload = JSON.parse(decodeBase64UrlToString(parts[1]));
    const candidates = [payload.sub, payload._id, payload.userId];
    const unique = new Set();
    for (const candidate of candidates) {
      if (typeof candidate !== 'string') {
        continue;
      }
      const value = candidate.trim();
      if (!value) {
        continue;
      }
      unique.add(value);
    }
    return Array.from(unique);
  } catch (_error) {
    return [];
  }
}
